import _ from 'lodash'
import { List, Map, isImmutable } from 'immutable'
import * as actionTypes from './actionTypes'
import { getAxios, getPreviewDynamicData, fturl } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { ftGetLocalStorage, parseURLParameters, processActionsSFItem } from '../../lib/common'
import { setVisibilityOfSFMappingElem } from '../../lib/setVisibilityOfSFMappingElem'
import { getParams } from '../../lib/processPortalRules'
import { recursivePrepareSFMapping, waitProcessingPickList } from './recursivePrepareSFMapping'
import { allowCoBrowse, SURVEY_TYPE } from '../../constants/features'
import {
  asyncIsAllowProcessSFFetchCacheData,
  isAllowProcessSFFetchCacheData,
  processSFFetchCacheData,
} from './pwa-tools'
import {
  SESSION_HEADER_NAME,
  SESSION_HEADER_SALT,
  SESSION_SALT_NAME,
  SESSION_TOKEN_NAME,
} from '../../constants/session'

const axios = getAxios()

export const processWidgetSFMapping =
  (type, path, widgetState, customParams, globalOnLoad = false, translateTo, filterList) =>
  async (dispatch, getState) => {
    try {
      let state = getState()
      let allowOffline =
        state.getIn(['project', 'Settings', 'allowOffline'], false) ||
        (await asyncIsAllowProcessSFFetchCacheData(state))
      if (allowCoBrowse) {
        if (
          state.getIn(['project', 'Settings', 'coBrowse', 'mode'], 'user') !== 'user' &&
          state.getIn(['project', 'Settings', 'coBrowse', 'status'], false)
        ) {
          return null
        }
      }
      if (type == 'translate') {
        let urlParams = parseURLParameters()
        if (!state.get('sfPickListLang') && !state.get('FTLang')) {
          if (urlParams.FTLang) {
            return false
          }
        }
      } else if (type == 'onload') {
        let urlParams = parseURLParameters()
        if (urlParams.FTLang) {
          translateTo = urlParams.FTLang
        }
      }
      if (translateTo == 'default') {
        translateTo = ''
      }

      const sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
      if (sfMapping) {
        let list = {}
        let widgetsData = {}
        let hashCustomActions = {}
        let isBackgroundMode = false
        if (type === 'custom') {
          isBackgroundMode = true
        }
        if (isImmutable(customParams)) {
          _.each(customParams.toJS(), function (job) {
            if (!job.runInBackground) {
              isBackgroundMode = false
            }
            _.each(job.items, function (row) {
              hashCustomActions[row.value] = row
            })
          })
        }

        if (isImmutable(widgetState)) {
          widgetsData = widgetState.toJS()
        }
        const params = getParams(state)
        if (path && _.isArray(path)) {
          path = path.join('.')
        }

        let messages = []

        list = recursivePrepareSFMapping(sfMapping, type, path, widgetsData, params, false, messages, hashCustomActions)
        if (!Object.keys(list).length) {
          return false
        }

        if (filterList && _.isArray(filterList)) {
          _.each(list, function (row, key) {
            if (key && filterList.indexOf(key) === -1) {
              delete list[key]
            }
          })
        }

        if (isBackgroundMode) {
          messages = []
        }

        let postList = {}
        const page = state.getIn(['project', 'Pages'], List()).find((page) => page.get('_id') === state.get('page'))
        const isPublic = state.getIn(['project', 'isPublic'], false)
        if (page || state.get('page') == 'signin' || state.get('page') == 'register') {
          const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
          if (
            (!isPublic && page?.get?.('access') !== 'public') ||
            state.get('page') == 'signin' ||
            state.get('page') == 'register'
          ) {
            if (!isUserSignIn) {
              return false
            }
          }
        }

        const pageUID = state
          .getIn(['project', 'Pages'], List())
          .find((page) => page.get('_id') === state.get('page'))
          ?.get?.('uid')
        if (pageUID && type === 'onload') {
          _.each(list, (entry, key) => {
            let pages = sfMapping[key]?.pages || []
            if (globalOnLoad && !pages.length) {
              postList[key] = entry
            } else if (pages.indexOf(pageUID) !== -1) {
              postList[key] = entry
            } else if (pages.indexOf('param') !== -1 && globalOnLoad) {
              postList[key] = entry
            }
          })
        } else {
          postList = list
        }

        if (!_.isEmpty(postList)) {
          if (messages.length > 0) {
            dispatch({
              type: actionTypes.SHOW_LOADING_WINDOW,
              payload: {
                messages: messages,
              },
            })
          }

          setVisibilityOfSFMappingElem(sfMapping, postList, true, true, state, dispatch)
          processActionsSFItem(sfMapping, postList, true, 'duringIntegration', dispatch)
          let guid = _.get(getPreviewDynamicData(), ['guid'])
          if (state.get('isNoBackGroundLoad')) {
            guid = null
          } else if (!globalOnLoad) {
            guid = null
          }
          if (isAllowProcessSFFetchCacheData(state)) {
            return dispatch(processSFFetchCacheData(postList))
          }
          let isProcessPickListLoad = false
          let pickListCurrentRequest = {}
          try {
            _.each(postList, (row, key) => {
              if (sfMapping[key]) {
                let item = sfMapping[key]
                if (item.isSyncLoadPickList && (!globalOnLoad || !window.EventSource)) {
                  isProcessPickListLoad = true
                  if (!window.ftProcessingLoadPickList) {
                    window.ftProcessingLoadPickList = {}
                  }
                  if (!window.ftProcessingLoadPickList[key]) {
                    window.ftProcessingLoadPickList[key] = {
                      jobs: {},
                      step: 0,
                    }
                  }
                  window.ftProcessingLoadPickList[key].step++
                  let currentStep = window.ftProcessingLoadPickList[key].step
                  window.ftProcessingLoadPickList[key].jobs[currentStep] = 'processing'
                  pickListCurrentRequest[key] = currentStep
                }
              }
            })
          } catch (err) {
            console.error(err.stack)
          }
          if (globalOnLoad && window.EventSource) {
            try {
              if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
                console.log('onload sf get >>> ', Object.keys(postList))
              }

              let requestGID = uuid()
              if (!window.processingRequest) {
                window.processingRequest = {}
              }
              window.processingRequest[requestGID] = true
              const recursiveProcessSSe = (attemp) => {
                if (attemp >= 3) {
                  asyncIsAllowProcessSFFetchCacheData(state).then((status) => {
                    if (status) {
                      dispatch(processSFFetchCacheData(postList))
                    }
                  })
                  return false
                }

                let sessionStorage = {}
                try {
                  const token = ftGetLocalStorage(SESSION_TOKEN_NAME)
                  if (token) {
                    sessionStorage[SESSION_HEADER_NAME] = token
                  }
                  const salt = ftGetLocalStorage(SESSION_SALT_NAME)
                  if (salt) {
                    sessionStorage[SESSION_HEADER_SALT] = salt
                  }
                } catch (err) {}
                const sse = new EventSource(
                  '/webprojects/get/sse/sfmapping?data=' +
                    encodeURIComponent(
                      JSON.stringify({
                        list: postList,
                        translateTo: translateTo,
                        guid: guid,
                        fturl,
                        sfAuthHash: _.get(getPreviewDynamicData(), ['ssoParams', 'sfAuthHash']),
                        ...sessionStorage,
                      })
                    ),
                  { withCredentials: true }
                )

                sse.addEventListener('pull-data', (e) => {
                  let data = e.data
                  if (data && Object.keys(data)) {
                    try {
                      data = JSON.parse(data)
                      if (data) {
                        if (!data.status) {
                          if (data.error == 'session_expired') {
                            if (state.get('page') != 'signin') {
                              window.__FT_PROJECT__API__.navigateToSignInPage()
                            }
                            dispatch({
                              type: actionTypes.PROCESS_SF_MAPPING,
                              payload: {
                                data: {},
                                sfPickListLang: translateTo,
                                isShowLoading: false,
                                isOnLoadProject: true,
                                loadingMessages: {},
                                sfMessages: {},
                              },
                            })
                            return false
                          }
                        }

                        // data = formatSFMappingResult(data);

                        let isShowLoading = false
                        let loadingMessages = {}
                        if (data && data.messages && Object.keys(_.omit(data.messages, ['canceled'])).length) {
                          isShowLoading = true
                          loadingMessages.type = 'error'
                          loadingMessages.isAlloClose = true
                          loadingMessages.list = []
                          _.each(data.messages, (msg, key) => {
                            if (key != 'canceled') {
                              loadingMessages.list.push(msg)
                            }
                          })
                        }

                        dispatch({
                          type: actionTypes.PROCESS_SF_MAPPING,
                          payload: {
                            data,
                            isShowLoading,
                            isOnLoadProject: true,
                            sfPickListLang: translateTo,
                            loadingMessages,
                            sfMessages: data ? _.omit(data.messages, ['canceled']) : {},
                            list: postList,
                          },
                        })
                        let displayElementsList = {
                          [data.item]: list[data.item],
                        }
                        _.each(postList, (v, k) => {
                          displayElementsList[k] = k
                        })
                        if (_.isArray(data.item)) {
                          _.each(data.item, function (rowUID) {
                            displayElementsList[rowUID] = list[rowUID]
                          })
                        } else {
                          displayElementsList[data.item] = list[data.item]
                        }
                        dispatch({
                          type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
                          payload: {
                            list: displayElementsList,
                            params: data.messages,
                          },
                        })

                        if (state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE) {
                          dispatch({
                            type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
                            payload: {},
                          })
                        }
                      }
                    } catch (error) {
                      console.error(error)
                    }
                  }
                })
                sse.addEventListener('close', (e) => {
                  try {
                    waitProcessingPickList(isProcessPickListLoad, pickListCurrentRequest, true)
                  } catch (err) {
                    console.error(err.stack)
                  }
                  delete window.processingRequest[requestGID]
                  dispatch({ type: actionTypes.CLOSE_LOADING_WINDOW })
                  sse.close()
                })
                sse.onerror = (ev, e) => {
                  console.log('onerror >>>', e)
                  sse.close()
                  if (!allowOffline) {
                    dispatch({
                      type: actionTypes.FETCH_DATA_ERROR,
                      payload: {
                        error: 'An error occurred, try again later',
                      },
                    })
                  }
                  setTimeout(function () {
                    recursiveProcessSSe(attemp + 1)
                  }, 2 * 1000)

                  if (attemp >= 2) {
                    window.processingRequest = {}
                    dispatch({
                      type: actionTypes.CLOSE_LOADING_WINDOW,
                    })
                  }
                }
              }
              recursiveProcessSSe(0)
            } catch (error) {
              console.log('error >>>', error)
              dispatch({
                type: actionTypes.FETCH_DATA_ERROR,
                payload: {
                  error: 'An error occurred, try again later',
                },
              })
              dispatch({
                type: actionTypes.CLOSE_LOADING_WINDOW,
              })
            }
          } else {
            if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
              console.log('onload sf get >>> ', Object.keys(postList))
            }

            let requestGID = uuid()
            if (!window.processingRequest) {
              window.processingRequest = {}
            }
            window.processingRequest[requestGID] = true

            let { status, data } = await axios.post('/webprojects/get/sfmapping', {
              data: {
                list: postList,
                guid: guid,
              },
            })

            try {
              waitProcessingPickList(isProcessPickListLoad, pickListCurrentRequest, true)
            } catch (err) {
              console.error(err.stack)
            }
            delete window.processingRequest[requestGID]
            // data = formatSFMappingResult(data);

            if (!data.status) {
              if (data.error == 'session_expired') {
                if (state.get('page') != 'signin') {
                  window.__FT_PROJECT__API__.navigateToSignInPage()
                }
                dispatch({
                  type: actionTypes.PROCESS_SF_MAPPING,
                  payload: {
                    data: {},
                    isShowLoading: false,
                    isOnLoadProject: true,
                    loadingMessages: {},
                    sfMessages: {},
                  },
                })
                return false
              }
            }

            let isShowLoading = false
            let loadingMessages = {}
            if (data && data.messages && Object.keys(_.omit(data.messages, ['canceled'])).length) {
              isShowLoading = true
              loadingMessages.type = 'error'
              loadingMessages.isAlloClose = true
              loadingMessages.list = []
              _.each(_.omit(data.messages, ['canceled']), (msg) => {
                loadingMessages.list.push(msg)
              })
            }

            dispatch({
              type: actionTypes.PROCESS_SF_MAPPING,
              payload: {
                data,
                isShowLoading,
                isOnLoadProject: true,
                loadingMessages,
                sfMessages: data ? _.omit(data.messages, ['canceled']) : {},
                list: postList,
              },
            })

            if (state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE) {
              dispatch({
                type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
                payload: {},
              })
            }

            dispatch({
              type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
              payload: {
                list: postList,
                params: data.messages,
              },
            })
          }
        }
      }
      // await Promise.all(_.map(
      //     processChildWidgets(
      //         state.getIn(['widgets', 'current'], Map()).toJS(),
      //         state.getIn(['widgets', 'data'], Map()).toJS(),
      //         [state.getIn(['widgets', 'current', '_id'])]
      //     ),
      //     data => processChildWidgetSFMapping(data, type, path, widgetState, customParams, state, dispatch)
      // ))
    } catch (error) {
      console.error('processWidgetSFMapping err >>>> ', error)
      dispatch({
        type: actionTypes.PROCESS_SF_MAPPING,
        payload: {
          data: {},
          isShowLoading: false,
          loadingMessages: [],
        },
      })
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message: `An error occurred, try again later.`,
        },
      })
    }
  }
